// filepath: src/firebase/firestore/usePIR.js
import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch a single PIR document by its id.
 * Returns: { data, loading, error }
 */
export function usePIR(pirId) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!pirId) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);

        fetch(`${BASE}/api/intelligence-requests/${encodeURIComponent(pirId)}`, {headers: authHeaders()})
            .then((r) => r.status === 404 ? null : r.ok ? r.json() : Promise.reject(new Error(`${r.status}`)))
            .then((doc) => { setData(doc); setLoading(false); })
            .catch((err) => { setError(err); setLoading(false); });
    }, [pirId]);

    return {data, loading, error};
}
